// PageNavMenuReportItem
// ***********************************************************************************************************************
import { List, Typography } from "@mui/material";
import * as React from "react";
import { ReportSharingType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IReportItem, ReportItem } from "../../../models/report/reportItem";
import { IPageNavMenuReportItemItem, PageNavMenuReportItemItem, PageNavMenuReportItemReportLine } from "./PageNavMenuItemReportItem";

export interface IPageNavMenuReportListProp {
    classes?: boolean;
    canRemoveSharedReports: boolean;
    showingSavedReports: boolean;
    items: IReportItem[];
    standardReports: IReportItem[];
    hidden?: boolean;
    activeItemId: string;
    activeStandardItemId: string;
    title: string;
    onSetActiveItem: (reportId: string) => void;
    onSetActiveStandardItem: (reportId: string) => void;
}

export interface IPageNavMenuReportListState {
    items: IPageNavMenuReportItemItem[];
}

export class PageNavMenuReportList extends React.Component<IPageNavMenuReportListProp, IPageNavMenuReportListState> {
    private getItems = (props: IPageNavMenuReportListProp): IPageNavMenuReportItemItem[] => {
        if (props.showingSavedReports) {
            const userReports = props.items.filter(i => i.reportSharingType === ReportSharingType.NotShared);
            let result: IPageNavMenuReportItemItem[] = [];
            if (userReports.length > 0) {
                result.push(new PageNavMenuReportItemItem({ reportItem: null, title: Translations.MyReports }));
                result = result.concat(userReports.map(i => new PageNavMenuReportItemItem({ reportItem: i, title: null })));
            }
            const standardAndSharedReports = ReportItem.getSharedAndStandardReports(props.standardReports, props.items.filter(i => i.reportSharingType > ReportSharingType.NotShared));
            if (standardAndSharedReports.length > 0) {
                result.push(new PageNavMenuReportItemItem({ reportItem: null, title: Translations.ReportsStandard }));
                result = result.concat(standardAndSharedReports.map(i => new PageNavMenuReportItemItem({ reportItem: i, title: null })));
            }
            return result;
        } else {
            return props.items.map(i => new PageNavMenuReportItemItem({ reportItem: i, title: null }));
        }
    };

    constructor(props: IPageNavMenuReportListProp) {
        super(props);
        this.state = {
            items: this.getItems(props)
        };
    }

    componentDidUpdate(prevProps: IPageNavMenuReportListProp, prevState: IPageNavMenuReportListState): void {
        const props = this.props;
        if (ReportItem.getItemsHash(prevProps.standardReports, prevProps.items) === ReportItem.getItemsHash(props.standardReports, props.items)) return;
        this.setState({
            items: this.getItems(props)
        });
    }

    render() {
        const props = this.props;
        if (props.hidden) return null;
        const reports = this.state.items;
        return (
            <List className={"menuItem" + (props.classes ? " " + props.classes : "")}>
                {reports.map((report) => {
                    return (report.reportItem
                        ? <PageNavMenuReportItemReportLine
                            key={report.reportItem.id}
                            classes={props.classes}
                            item={report.reportItem}
                            canRemoveSharedReports={report.reportItem.isUserReport ? props.canRemoveSharedReports : false}
                            activeItemId={report.reportItem.isUserReport ? props.activeItemId : props.activeStandardItemId}
                            onSetActiveItem={report.reportItem.isUserReport ? props.onSetActiveItem : props.onSetActiveStandardItem}
                        />
                        : <Typography key={report.title} variant="caption">{report.title}</Typography>
                    );
                })}
            </List>
        );
    }
}